import {
  DataGrid,
  GridColDef,
  GridColumnHeaderParams,
  GridRowId,
} from "@mui/x-data-grid";
import React from "react";
import styled from "@emotion/styled";
import { GridPaginationModel } from "@mui/x-data-grid/models/gridPaginationProps";
import { GridFilterModel } from "@mui/x-data-grid/models/gridFilterModel";
import CustomColumnHeader from "./CustomColumnHeader";

export interface VehicleTest {
  id: string;
  testAddress: string;
  kfn: string; // Assuming all fields are strings; adjust types as necessary
  fn: string;
  audiPartNumber: string;
  hardwarePartNumber: string;
  hwVersion: string;
  bootloader: string;
  swVersion: string;
  keyType: string;
  flashTester: boolean; // Assuming it's a boolean
  timestamp: string; // or Date depending on how you handle dates
}

export interface Rows {
  list: VehicleTest[];
  count: number;
}

export interface DataTableProps {
  rows: Rows;
  columns: any;
  className?: string;
  filterModel: GridFilterModel;
  setFilterModel: (model: GridFilterModel) => void;
  pagination?: GridPaginationModel;
  pageSizeOptions?: Array<number>;
  checkboxSelection?: boolean;
  onSortModelChange?: any;
  onFilterModelChange: (model: GridFilterModel) => void;
  onPaginationModelChange: (model: GridPaginationModel) => void;
  onRowSelectionModelChange: (selection: GridRowId[], details: any) => void;
}

const DataTable = (props: DataTableProps) => {
  const columns: GridColDef[] = props.columns.map((column: GridColDef) => ({
    ...column,
    renderHeader: (params: GridColumnHeaderParams) => (
      <CustomColumnHeader {...params} />
    ),
    sortable: false,
  }));

  return (
    <Wrapper className={props.className}>
      <DataGrid
        rows={props.rows.list}
        columns={columns}
        filterModel={props.filterModel}
        initialState={{
          pagination: {
            paginationModel: props.pagination || { page: 0, pageSize: 20 },
          },
        }}
        columnBuffer={2}
        paginationMode="server"
        filterMode="server"
        sortingMode="server"
        onFilterModelChange={(model) => {
          props.setFilterModel(model);
          props.onFilterModelChange(model);
        }}
        rowCount={props.rows.count / 10}
        onSortModelChange={props.onSortModelChange}
        pageSizeOptions={
          props.pageSizeOptions || [1, 2, 3, 4, 5, 10, 20, 25, 30, 35, 50]
        }
        checkboxSelection={props.checkboxSelection}
        onPaginationModelChange={props.onPaginationModelChange}
        onRowSelectionModelChange={props.onRowSelectionModelChange}
        keepNonExistentRowsSelected
        localeText={{
          MuiTablePagination: {
            labelRowsPerPage: "Zeilen pro Seite",
            labelDisplayedRows: ({ from, to, count, page }) => {
              const first = from === 0 ? 0 : (from - 1) * 10 + 1;
              const last = to * 10;
              return `Seite: ${page + 1}, Reihen ${first}-${last} Von ${
                props.rows.count
              }`;
            },
          },
        }}
      />
    </Wrapper>
  );
};

export default DataTable;

const Wrapper = styled.div`
  width: calc(100% - 40px);
`;
